import { Card, Divider, Grid, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import FormEinField from '../../../FormFields/FormEinField';
import FormTitle from '../../../FormFields/FormTitle';
import { BENEFITS } from '../../../formQuestionsEnum';
import { formCardStyle } from '../../../TransitionStyles';

BenefitInformationForm.propTypes = {
  permissions: PropTypes.object,
};

export default function BenefitInformationForm({ permissions }) {
  const [focusedField, setFocusedField] = useState(null);

  return (
    BENEFITS.EIN_NUMBER.id in permissions && (
      <Card sx={formCardStyle}>
        <Typography sx={{ mb: 1 }} align="center" variant="body1" color="info.main">
          Benefits Information
        </Typography>
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
        <Grid container spacing={1.5}>
          <Grid item xs={4}>
            <FormTitle fieldAttributes={{ questionTitle: 'EIN number' }} />
            <FormEinField
              fieldName={BENEFITS.EIN_NUMBER.fieldName}
              focusedField={focusedField}
              setFocusedField={setFocusedField}
              fieldAttributes={{
                isEditable: permissions[BENEFITS.EIN_NUMBER.id],
              }}
            />
          </Grid>
        </Grid>
      </Card>
    )
  );
}
